import React from 'react';
import { Card, CardContent } from './ui/card';
import { CheckCircle2 } from 'lucide-react';

const ProcessStep = ({ step, index }) => {
  return (
    <Card className="db-orb-card relative bg-gradient-to-r from-white/5 to-white/10 border-white/10 hover:border-orange-500/50 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_50px_rgba(249,115,22,0.12)] group">
      <span className="pointer-events-none absolute top-2 right-4 text-7xl font-bold text-orange-500/10 leading-none">
        {String(index + 1).padStart(2, '0')}
      </span>
      <CardContent className="p-6 relative z-10">
        <div className="db-feature-row">
          <div className="bg-gradient-to-br from-orange-500 to-amber-500 text-white w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
            <CheckCircle2 className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
          </div>
          <div className="db-feature-copy">
            <h3 className="db-feature-title text-xl font-bold text-white mb-2 group-hover:text-orange-500 transition-colors">
              {step.title}
            </h3>
            <p className="text-neutral-400">
              {step.description}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProcessStep;
